import React from "react";

import { ResponseType, OptionsType } from "commons/types/http";

import useHttpManaged from "hooks/useHttpManaged";

import { ListResponse, PathParamsWithId, ResponseWithId } from "commons/types/api/common";

import {
    SectionHighlightProductBody,
    SectionHighlightProductListItem,
} from "types/api/blocks/sectionHighlightProduct";

import { AdvancedListRequest } from "types/api/commons";

function useSectionHighlightProductApi() {
    const { get, del, post, put } = useHttpManaged();
    const createSectionHighlightProduct = React.useCallback((body: SectionHighlightProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ResponseWithId> => {
        return post<undefined, undefined, SectionHighlightProductBody, ResponseWithId>({
            url: "/blocks/section-highlight-product",
            body: body,
            options: options,
            headers: headers
        });
    }, [post]);
    const updateSectionHighlightProduct = React.useCallback((pathParams: PathParamsWithId, body: SectionHighlightProductBody, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return put<PathParamsWithId, undefined, SectionHighlightProductBody, null>({
            url: "/blocks/section-highlight-product/:id",
            pathParams: pathParams,
            body: body,
            options: options,
            headers: headers
        });
    }, [put]);
    const deleteSectionHighlightProduct = React.useCallback((pathParams: PathParamsWithId, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<null> => {
        return del<PathParamsWithId, undefined, null>({
            url: "/blocks/section-highlight-product/:id",
            pathParams: pathParams,
            options: options,
            headers: headers
        });
    }, [del]);
    const getAllSectionHighlightProduct = React.useCallback((queryParams: AdvancedListRequest, options?: OptionsType, headers?: { [x: string]: string }): ResponseType<ListResponse<SectionHighlightProductListItem>> => {
        return get<undefined, AdvancedListRequest, ListResponse<SectionHighlightProductListItem>>({
            url: "/blocks/section-highlight-product",
            queryParams: queryParams,
            options: options,
            headers: headers
        });
    }, [get]);
    return {
        createSectionHighlightProduct,
        updateSectionHighlightProduct,
        deleteSectionHighlightProduct,
        getAllSectionHighlightProduct
    };
}

export default useSectionHighlightProductApi;